import { translate } from '../../../../../Greativ/helper/translation'

export default function __(key, replace) {
  return translate(window.shop_basket.translations, key, replace)
}
